import { TChatDataInListSchema } from '../../types/chatList';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EStarredChatsListActionTypes {
  SetPending = 'chats/starredChatsList/setPending',
  SetSucceed = 'chats/starredChatsList/setSucceed',
  SetFailed = 'chats/starredChatsList/setFailed',
}

export interface IStarredChatsListRequest {
  // timestamp последнего чата, последней страницы
  timestampStarred?: number;
}

export type TStarredChatsListActions =
  | ITypedReduxAction<EStarredChatsListActionTypes.SetPending, IStarredChatsListRequest>
  | ITypedReduxAction<EStarredChatsListActionTypes.SetSucceed, TChatDataInListSchema[]>
  | ITypedReduxAction<EStarredChatsListActionTypes.SetFailed, void>;
